// create sagas
import { call, put, takeLatest } from "redux-saga/effects";
import {
  getApplicationData,
  getApplicationDataSuccess,
  getApplicationDataFailure,
} from "./getApplicationDataSlice";
import { apiQueryWithToken } from "../../../services/apiBaseUrlConfig";
import { ENDPOINT } from "../../../services/endpoint.config";

function* getApplicationDetails() {
  try {
    const response = yield call(() =>
      apiQueryWithToken.get(ENDPOINT.GET_APPLICATION_DATA)
    );
    const responseData = response.data;
    yield put(getApplicationDataSuccess(responseData));
  } catch (error) {
    let errorMessage;
    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error && typeof error === 'object' && 'message' in error) {
      errorMessage = error.message;
    } else if (error && typeof error === 'object' && 'payload' in error) {
      errorMessage = error.payload;
    } else {
      errorMessage = undefined;
    }
    yield put(getApplicationDataFailure(errorMessage));
  }
}

function* watchApplicationData() {
  yield takeLatest(getApplicationData.type, getApplicationDetails);
}

export { getApplicationDetails };
export default watchApplicationData;
